import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { Calendar } from 'primeng/calendar';
import { CascadeSelect } from 'primeng/cascadeselect';
import { ColorPicker } from 'primeng/colorpicker';
import { Dropdown } from 'primeng/dropdown';
import { MultiSelect } from 'primeng/multiselect';
import { TreeSelect } from 'primeng/treeselect';

@Directive({
	standalone: true,
	selector: `
		p-dropdown,
		p-calendar,
		p-multiSelect,
		p-autoComplete,
		p-cascadeSelect,
		p-treeSelect,
		p-colorPicker
	`
})
export class PrimeNgDialogAppendDirective implements AfterViewInit
{
	private readonly el = inject(ElementRef);

	// Each resolves only when this directive is attached to that component type.
	private readonly dropdown = inject(Dropdown, { optional: true, self: true });
	private readonly calendar = inject(Calendar, { optional: true, self: true });
	private readonly multiSelect = inject(MultiSelect, { optional: true, self: true });
	private readonly autoComplete = inject(AutoComplete, { optional: true, self: true });
	private readonly cascadeSelect = inject(CascadeSelect, { optional: true, self: true });
	private readonly treeSelect = inject(TreeSelect, { optional: true, self: true });
	private readonly colorPicker = inject(ColorPicker, { optional: true, self: true });

	ngAfterViewInit(): void {
		// Defer so we run after PrimeNG reads template inputs like appendTo="body".
		// appendTo="body" sits under the MatDialog overlay z-index; mat-dialog-container does not.
		setTimeout(() => this.applyAppendTo(), 0);
	}

	private applyAppendTo(): void {
		const host = this.el.nativeElement as HTMLElement;
		const dialogContainer = host.closest('mat-dialog-container');

		// Outside MatDialog we keep PrimeNG defaults untouched.
		if (!dialogContainer) {
			return;
		}

		const comp =
			this.dropdown ??
			this.calendar ??
			this.multiSelect ??
			this.autoComplete ??
			this.cascadeSelect ??
			this.treeSelect ??
			this.colorPicker;

		if (comp) {
			comp.appendTo = dialogContainer;
		}
	}
}
